// The chrome every record-tab "link" dialog shares — the (+) on a record's
// detail-tab grid that links existing data (Aaron 2026-10-06: "(+) icons to add
// rows (link to data)"). Title, a Grid of the caller's fields, the error line,
// Cancel / <action>. Callers supply the fields and the submit; the frame owns
// the look, so every link dialog reads the same.
//
// Consumers: components/LinkAircraftDialog (inspection + directive Aircraft
// Lists), ads-and-sbs/record/DirectiveModelDialog (directive Config List),
// ads-and-sbs/record/DirectivePartDialog, ads-and-sbs/record/DirectiveTaskDialog.
import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";

interface Props {
  open: boolean;
  title: React.ReactNode;
  /** Grid ITEMS — the frame owns the container. */
  children: React.ReactNode;
  error?: string | null;
  submitLabel?: string;
  saving?: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export default function LinkDialogFrame({
  open,
  title,
  children,
  error,
  submitLabel = "Link",
  saving = false,
  onSubmit,
  onClose,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ pt: 1 }}>
          {children}
          {error && (
            <Grid item xs={12} role="alert" sx={{ color: "error.main", fontSize: 14 }}>
              {error}
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit} disabled={saving}>
          {submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

/** What a link write did, per item: a partial link names what got nothing, and why. */
export interface LinkOutcome {
  created: number;
  skipped: { label: string; reason: string }[];
}
